<table id="table" class="table table-bordered" width="100%" cellspacing="0">
  <thead>
    <tr>
      <th>{{ bookI18n?.isbnI18n }}</th>
      <th>{{ bookI18n?.titleI18n }}</th>
      <th>{{ bookI18n?.authorI18n }}</th>
      <th>{{ bookI18n?.categoryI18n }}</th>
      <th>{{ bookI18n?.publisherI18n }}</th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      <th>{{ bookI18n?.isbnI18n }}</th>
      <th>{{ bookI18n?.titleI18n }}</th>
      <th>{{ bookI18n?.authorI18n }}</th>
      <th>{{ bookI18n?.categoryI18n }}</th>
      <th>{{ bookI18n?.publisherI18n }}</th>
    </tr>
  </tfoot>
  <tbody>
    <tr *ngFor="let b of books">
      <td>{{ b.isbn }}</td>
      <td>{{ b.title }}</td>
      <td>{{ b.writer?.name }}</td>
      <td>{{ b.category?.category_name }}</td>
      <td>{{ b.publisher?.name }}</td>
    </tr>
  </tbody>
</table>
